import { api } from '@services/api';

type EmployeeDeleteProps = {
  idLogin: string;
};

export async function deleteEmployee({ idLogin }: EmployeeDeleteProps) {
  await api.delete(`/ravim/excluir_usuario/${idLogin}`);
}
